enum ResendEmailTypeEnum {
    SUBMITTED = "submitted",
}

export default ResendEmailTypeEnum;
